function DistanceCard() {
    this.Latitude = '';
    this.Longitude = '';
}
if (typeof exports !== 'undefined') {
    module.exports = DistanceCard;
}